export const IS_DEV: boolean = process.env.NODE_ENV === 'development'
export const API_ENDPOINT_SEARCH: string = '/api/search'
export const API_ENDPOINT_AUTOSUGGEST: string = '/api/suggest'
